import { Component, OnInit } from '@angular/core'
import { LoginFormComponent } from '../../../features/login/login-form/login-form.component'
import { MatCard } from '@angular/material/card'
import { ForgotFormComponent } from '../../../features/login/forgot-form/forgot-form.component'
import { CacheService } from '../../../core/services/cache/cache.service'
import { environment } from '../../../../environments/environment'

@Component({
  selector: 'login',
  imports: [LoginFormComponent, ForgotFormComponent, MatCard],
  templateUrl: './login.component.html',
  standalone: true,
})
export class LoginComponent implements OnInit {
  constructor(private cacheService: CacheService) {}

  version: string = environment.version

  ngOnInit() {
    this.cacheService.clearCache()
  }

  formForgotPass = false

  forgotPassword() {
    this.formForgotPass = !this.formForgotPass
  }
}
